function clickHandler(data, e) {
  if (typeof window.gaDebug !== 'undefined' && window.gaDebug === true) {
    e.preventDefault();
  }
  pushToDataLayer(data.event, data.actionProp, data.labelProp, data.action, data.label);
}

function determineActionText(el) {
  let text = '';
  if (el.getAttribute('data-ga-name')) {
    text = el.getAttribute('data-ga-name');
  } else if (el.getAttribute('aria-label')) {
    text = el.getAttribute('aria-label');
  } else if (el.tagName === 'A') {
    text = el.textContent;
  } else {
    const span = el.getElementsByTagName('span')[0];
    text = span ? span.textContent : el.textContent;
  }
  return text.trim();
}

function determineLabelText(el) {
  let text = '';
  if (el.tagName === 'A') {
    text = el.href;
  } else {
    const span = el.getElementsByTagName('span')[0];
    text = span ? span.textContent : el.textContent;
  }
  return text.trim();
}

function pushToDataLayer(event, actionProp, labelProp, action, label) {
  if (typeof window.dataLayer !== 'undefined') {
    const dataObj = {
      event: event,
    };
    dataObj[actionProp] = action;
    dataObj[labelProp] = label;
    if (typeof window.gaDebug !== 'undefined' && window.gaDebug === true) {
      console.table(dataObj);
    }
    window.dataLayer.push(dataObj);
  }
}

function pushToDataLayerDirectly(dataObj) {
  if (typeof window.dataLayer !== 'undefined') {
    if (typeof window.gaDebug !== 'undefined' && window.gaDebug === true) {
      console.table(dataObj);
    }
    window.dataLayer.push(dataObj);
  }
}

function queryFileName(el) {
  return el.href.split('\\').pop().split('/').pop();
}

function queryURL(el) {
  const url = el.getAttribute('href');
  return url ? url : '';
}

function submitHandler(event, action, form, value, e) {
  if (typeof window.gaDebug !== 'undefined' && window.gaDebug === true) {
    e.preventDefault();
  }
  const fd = new FormData(form);
  pushToDataLayer(event, action, fd.get(value));
}

function virtualPageview(url, title) {
  if (typeof window.dataLayer !== 'undefined') {
    const dataObj = {
      event: 'virtualPageview',
      virtualPageURL: url,
      virtualPageTitle: title,
    };
    if (typeof window.gaDebug !== 'undefined' && window.gaDebug === true) {
      console.table(dataObj);
    }
    window.dataLayer.push(dataObj);
  }
}

export {
  clickHandler,
  determineActionText,
  determineLabelText,
  pushToDataLayer,
  pushToDataLayerDirectly,
  queryFileName,
  queryURL,
  submitHandler,
  virtualPageview,
};
